import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

import { PurchaseRequestService, ProductsInRequest } from '../../services/purchase-request.service';
import { PurchaseOrderService } from '../../services/purchase-order.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';

@Component({
  selector: 'app-display-purchase-request',
  templateUrl: './display-purchase-request.component.html',
  styleUrls: ['./display-purchase-request.component.css']
})
export class DisplayPurchaseRequestComponent implements OnInit, OnDestroy {

  id: string;
  purchaseRequest: any = {};
  productsInRequest: any[] = [];
  get prsNotOrdered() { return this.productsInRequest.filter(({ordered}) => !ordered) };
  
  loggedUserId: string;
  loggedUserName: string;
  approvationNumber: number;

  purchaseReqSub: Subscription;
  purchaseOrderSub: Subscription;
  userSub: Subscription;

  modalActionsEraseRequest = new EventEmitter<string|MaterializeAction>();
  modalParamsEraseRequest = [{dismissible: true}];
  modalActionsApprovations = new EventEmitter<string|MaterializeAction>();
  modalParamsApprovation = [{dismissible: true}];

  constructor(
    private purchaseRequestService: PurchaseRequestService,
    private purchaseOrderService: PurchaseOrderService,
    private authService: AuthService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private prCmpaService: ProductCmpaService,
    private supplierService: CustomerSupplierService,
    private router: Router
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.loggedUserId = this.authService.currentUser.id;
    let userSub = this.userService.getUser(this.loggedUserId).subscribe(user => {
      this.loggedUserName = `${user.name} ${user.lastName}`;
      userSub.unsubscribe();
    });

    this.purchaseReqSub = this.purchaseRequestService.getPurchaseRequest(this.id).subscribe(([data]) => {
      var purchaseRequestData = {
        approved1: '',
        approved2: '',
        approved1Color: '',
        approved2Color: '',
        date: moment(data.createdAt).format('YYYY-MM-DD HH:ss'),
        folio: data.folio,
        notes: data.notes,
        productsInRequest: data.productsInRequest,
        requester: `${data.requesterObj.name} ${data.requesterObj.lastName}`,
        deliveryRequiredDate: data.deliveryRequiredDate || '',
        supplierName: '',
        canceled: data.canceled,
      };
      if(data.supplierRef){
        let sub = this.supplierService.getCustomerSupplier(data.supplierRef.id).subscribe(supplier => {
          sub.unsubscribe();
          purchaseRequestData.supplierName = supplier.name;
        });
      }
      this.productsInRequest = data.productsInRequest;
      console.log(this.productsInRequest, this.prsNotOrdered)
      if(data.approved1) {
        this.userSub = this.userService.getUser(data.approved1.id).subscribe(app1User => {
          purchaseRequestData.approved1 = `${app1User.name} ${app1User.lastName}`;
          purchaseRequestData.approved1Color = 'light-green-text text-darken-1';
        });
      } else {
        purchaseRequestData.approved1 = 'No aprobado';
        purchaseRequestData.approved1Color = 'red-text text-darken-2';
      }
      if(data.approved2) {
        this.userSub = this.userService.getUser(data.approved2.id).subscribe(app2User => {
          purchaseRequestData.approved2 = `${app2User.name} ${app2User.lastName}`;
          purchaseRequestData.approved2Color = 'light-green-text text-darken-1';
        });
      } else {
        purchaseRequestData.approved2 = 'No aprobado';
        purchaseRequestData.approved2Color = 'red-text text-darken-2';
      }
      this.purchaseRequest = purchaseRequestData;
      this.getProductNames(purchaseRequestData.productsInRequest);
    });
  }

  ngOnInit() {
    
  }
  ngOnDestroy() {
    this.purchaseReqSub.unsubscribe();
    if(this.userSub) this.userSub.unsubscribe();
    (this.purchaseOrderSub) ? this.purchaseOrderSub.unsubscribe() : null;
  }

  getProductNames(prCmpas: ProductsInRequest[]){
    let subs: Subscription[] = [];
    prCmpas.map(({productRef}) => productRef).map((prCmpaId, index) => {
      subs[index] = this.prCmpaService.getPrCmpa(prCmpaId).subscribe(([prCmpa]) => {
        subs[index].unsubscribe();
        let characs = prCmpa.characs.reduce((acc, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}`, '');
        this.purchaseRequest.productsInRequest[index].name = `${prCmpa.name} - ${characs}`;
      });
    });
  }

  approvePurchaseRequest() {
    this.purchaseRequestService.approvePurchaseRequest(this.id, this.approvationNumber, this.loggedUserId);
    this.closeApprovationModal();
  }
  displayOrder(orderId: string) {
    this.router.navigate([`/vw_purchase_req_order/${orderId}`]);
  }
  deletePurchaseRequest() {
    this.purchaseRequestService.deletePurchaseRequest(this.id);
    this.closeEraseModal();
    this.router.navigate(['/purchase_request']);
  }

  openApprovationModal(appNumber: number) {
    this.approvationNumber = appNumber;
    this.modalActionsApprovations.emit({ action: 'modal', params: ['open'] });
  }
  closeApprovationModal() {
    this.approvationNumber = null;
    this.modalActionsApprovations.emit({ action: 'modal', params: ['close'] });
  }
  openEraseModal() {
    this.modalActionsEraseRequest.emit({ action: 'modal', params: ['open'] });
  }
  closeEraseModal() {
    this.modalActionsEraseRequest.emit({ action: 'modal', params: ['close'] });
  }

  onOrder(){
    localStorage.prs = JSON.stringify([this.purchaseRequest.folio, this.prsNotOrdered.map(({productRef: id}) => id)]);
    this.router.navigate(['/order_purchase_request']);
  }

}
